import { render, staticRenderFns } from "./UpdateImage.vue?vue&type=template&id=2fe862a8&"
import script from "./UpdateImage.vue?vue&type=script&lang=js&"
export * from "./UpdateImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports